<template>
    <div class="news">
        <div class="news_hea">
            <myHeaderW></myHeaderW>
        </div>
        <div class="news_ban">
            <img :src="$httpImg +'/img/bag/cooperation.png'" />
            <div class="news_ban_center">
                <h4>新闻中心</h4>
                <p>news</p>
            </div>
        </div>
        <div class="news_cen">
            <div class="hotNews_center" v-if="data.newsList.length > 0">
                <h5 id="news0">热点新闻</h5>
                <div class="top">
                    <div class="item_new" style="width: 750px;" @click="goto('/details', data.newsList[0].id)">
                      <div style="height: 200px;"> <img :src="data.newsList[0].cover"></div>
                       
                        <div class="item_new_text">
                            <h6>{{ data.newsList[0].title }}</h6>
                            <p>{{ data.newsList[0].createTime }}</p>
                        </div>
                    </div>
                    <div class="item_new" @click="goto('/details', data.newsList[1].id)">
                        <img :src="data.newsList[1].cover">
                        <div class="item_new_text">
                            <h6>{{ data.newsList[1].title }}</h6>
                            <p>{{ data.newsList[1].createTime }}</p>
                        </div>
                    </div>


                </div>
                <div class="bottom">
                    <div class="item_new" @click="goto('/details', data.newsList[2].id)">
                        <img :src="data.newsList[2].cover">
                        <div class="item_new_text">
                            <h6>{{ data.newsList[2].title }}</h6>
                            <p>{{ data.newsList[2].createTime }}</p>
                        </div>
                    </div>
                    <div class="item_new" @click="goto('/details', data.newsList[3].id)">
                        <img :src="data.newsList[3].cover">
                        <div class="item_new_text">
                            <h6>{{ data.newsList[3].title }}</h6>
                            <p>{{ data.newsList[3].createTime }}</p>
                        </div>
                    </div>
                    <div class="item_new" @click="goto('/details', data.newsList[4].id)">
                        <img :src="data.newsList[4].cover">
                        <div class="item_new_text">
                            <h6>{{ data.newsList[4].title }}</h6>
                            <p>{{ data.newsList[4].createTime }}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="news_list">
            <div class="news_list_cen">
                <h5 id="news1">全部新闻</h5>
                <div class="ul">
                    <div class="li" v-for=" i in data.dataSce" :key="i" @click="goto('/details', i.id)">
                        <p>{{ i.title }}</p>
                        <p>{{ i.intro }}&nbsp;&nbsp;&nbsp;&nbsp;{{ i.createTime }}</p>
                    </div>
                </div>
                <div class="paging">
                    <el-pagination background layout="prev, pager, next" :current-page="data.page.pageNo"
                        :pager-count="data.page.pageSize" :total="data.total" />
                </div>
            </div>

        </div>

        <myFooter></myFooter>

    </div>
</template>

<script>
import { reactive, ref, toRefs, } from "@vue/reactivity";
import myHeaderW from '@/components/myHeaderW.vue'
import myFooter from '@/components/myFooter.vue'
import { getrichTextlist } from '@/comm/api'
import { onMounted } from "vue";
import { useRouter } from 'vue-router';
export default {
    components: {
        myHeaderW,
        myFooter
    },
    setup() {
        const activeName = ref('0')
        let data = reactive({
            dataSce: [],
            newsList: [],
            total: 0,
            page: {
                pageNo: 1,
                pageSize: 10,
            }
        });

        const handleClick = (tab, event) => {
            console.log(tab, event)
        }
        const getrichText = async (params, name) => {
            try {
                const res = await getrichTextlist(params);
                console.log(1, res);
                if (res.code == 1) {
                    data[name] = res.data.records
                }
                if (name == 'dataSce') {
                    data.total = res.data.total
                }
            } catch (err) {
                console.error("失败", err);

            }
        };
        const router = useRouter()
        const goto = (path, id) => {
            router.push({ path: path, query: { id: id } })
        }
        onMounted(() => {
            getrichText({ pageNo: 1, pageSize: 5 }, 'newsList')
            getrichText(data.page, 'dataSce')
        })
        return {
            data,
            goto,
            activeName,
            handleClick
        }
    }
}
</script>

<style lang="scss" scoped>
.news {
    background: #fff;
}

.news_hea {
    width: 100%;
    background: #fff;
}

.news_ban {
    position: relative;

    img {
        position: relative;
        width: 100%;
    }

    .news_ban_center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        h4 {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 45px;
            color: #FFFFFF;
            text-align: center;
        }

        p {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 20px;
            text-align: center;
            color: #FFFFFF;
        }
    }

}

.news_cen {
    background: #F5F5F5;

    .hotNews_center {
        width: 1200px;
        margin: 0px auto;
        padding: 40px 0px;
        height: 800px;

        h5 {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            margin-bottom: 30px;
        }

        .top {
            display: flex;
            align-items: center;
            justify-content: space-evenly;

        }

        .item_new_text {
            background: #FFFFFF;
            padding: 15px;
            height: 80px;
            border-radius: 0px 0px 15px 15px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            h6 {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #0C0D0E;

            }

            p {
                font-family: Microsoft YaHei;
                font-weight: 300;
                font-size: 16px;
                color: #848484;
            }
        }

        .top>.item_new {
            width: 400px;
            height: 300px;
            border-radius: 15px;

            img {
                width: 100%;
                height: 200px;
                border-radius: 15px 15px 0px 0px;
            }
        }

        .bottom {
            display: flex;
            align-items: center;
            justify-content: space-evenly;

        }

        .bottom>.item_new {
            width: 375px;
            margin-top: 40px;
            background: #FFFFFF;
            border-radius: 15px;
            height: 300px;


            img {
                width: 100%;
                height: auto;
                max-height: 255px;
                border-radius: 15px 15px 0px 0px;
            }
        }
    }
}

.news_list {
    background: #fff;
    height: 600px;

    .news_list_cen {
        width: 1200px;
        margin: 0 auto;

        h5 {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            margin-top: 40px;
            margin-bottom: 40px;
        }

        .ul {
            width: 100%;

            .li {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #272727;
                cursor: pointer;

            }
        }

        .paging {
            width: max-content;
            margin: 0px auto;
            margin-top: 50px;
        }
    }

    :deep(.el-pagination.is-background .btn-prev:disabled) {
        border-radius: 50% !important;
    }

    :deep(.el-pagination.is-background .btn-next.is-active),
    :deep(.el-pagination.is-background .btn-prev.is-active),
    :deep(.el-pagination.is-background .el-pager li.is-active) {
        border-radius: 50% !important;
    }

    :deep(.el-pagination.is-background .btn-next),
    :deep(.el-pagination.is-background .btn-prev),
    :deep(.el-pagination.is-background .el-pager li) {
        border-radius: 50% !important;
    }

    :deep(.el-pager li) {
        border-radius: 50% !important;
    }

    :deep(.el-pagination.is-background .el-pager li.is-active) {
        background: #38C9C8 !important;
    }
}
</style>